export { EMAIL_PATTERN, EMAIL_PATTERN_STRING } from './validationUtils';

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
